/**
 * Microsoft Clarity loader — injected as an external script (never inline)
 * so the CSP can stay free of 'unsafe-inline' in script-src.
 *
 * Clarity masks all input/textarea content by default, which is required
 * here: the form collects names, contact details, and addresses.
 */
interface ClarityFn {
  (...args: unknown[]): void
  q?: unknown[][]
}

declare global {
  interface Window {
    clarity?: ClarityFn
  }
}

export function loadClarity(projectId: string): void {
  if (!projectId || window.clarity) return

  const stub: ClarityFn = (...args: unknown[]) => {
    ;(stub.q = stub.q ?? []).push(args)
  }
  window.clarity = stub

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.clarity.ms/tag/${encodeURIComponent(projectId)}`
  document.head.appendChild(script)
}
